import { ISendMailRequest } from 'apiConnector/life-ring';
import { useToggleFeature } from 'hooks/useToggleFeature';
import LiferingModalWithScreenshot from 'layouts/main/sp-header/LiferingModalWithScreenshot';
import { ComponentProps, MouseEventHandler, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { helpCenterActions } from 'state/helpRequest/actions';

export function HelpRequestButton({
  children,
  onClick,
  smartQuotes,
  ...props
}: ComponentProps<'button'> & { smartQuotes?: ISendMailRequest['smartQuotes'] }) {
  const hasFeature = useToggleFeature('helpCenterEnhancement');
  const dispatch = useDispatch();
  const [opened, setOpened] = useState(false);

  const clickHandler: MouseEventHandler<HTMLButtonElement> = event => {
    event.stopPropagation();
    if (hasFeature) {
      dispatch(helpCenterActions.open('request feedback from help center'));
    } else {
      setOpened(true);
    }
    onClick?.(event);
  };

  const closeModal = useCallback(() => setOpened(false), []);

  return (
    <>
      <button onClick={clickHandler} {...props}>
        {children}
      </button>
      {!hasFeature && opened && (
        <LiferingModalWithScreenshot onClose={closeModal} isOpened={opened} smartQuotes={smartQuotes} />
      )}
    </>
  );
}
